// extracted by mini-css-extract-plugin
export default {"wrapper":"Style_wrapper__eF7zS","wrapperHome":"Style_wrapperHome__95MOR"};